// 供应商高级弹窗配置
export const carrierConfig = {
    name: '供应商',
    value: 'carrierCode',
    type: 'advance',
    advanceNotSearch: true,
    queryConditionRequired: true,
    border: true,
    unfold: true,
    advanceConfig: [
        { prop: 'supplierCode', value: '供应商编码' },
        { prop: 'supplierNameCn', value: '供应商名称' }
    ],
    tableConfig: [
        { prop: 'supplierCode', value: '供应商编码' },
        { prop: 'supplierNameCn', value: '供应商名称' }
    ],
    method: 'post',
    prefix: '/api-tms',
    advanceUrl: '/srm/supplier/search',
    cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode']
};

// 供应商合同高级弹窗配置
export const contractConfig = {
    name: '供应商合同',
    type: 'advance',
    value: 'contractCode',
    multiple: true,
    border: true,
    dialogWidth: '800px',
    multipleTableColumn: {
        prop: 'contractName', value: '合同名称'
    },
    advanceConfig: [
        { prop: 'supplierCode', value: '供应商编码' }
    ],
    tableConfig: [
        { prop: 'contractCode', value: '合同编码' },
        { prop: 'contractName', value: '合同名称' }
    ],
    method: 'post',
    prefix: '/api-antms/query',
    advanceUrl: '/lsrm/query/contract',
    // paramType: true, // 是否采用param对象传参
    cbParams: ['contractName#names', 'contractCode#codes']
};

// 供应商司机高级弹窗配置
export const driverConfig = {
    name: '供应商司机',
    value: 'driverCode',
    type: 'advance',
    multiple: true,
    border: true,
    dialogWidth: '800px',
    multipleTableColumn: {
        prop: 'driverName', value: '司机名称'
    },
    advanceConfig: [
        { prop: 'supplierCode', value: '供应商编码' }
    ],
    tableConfig: [
        { prop: 'driverCode', value: '司机编码' },
        { prop: 'driverName', value: '司机名称' }
    ],
    method: 'post',
    prefix: '/api-antms/query',
    advanceUrl: '/lsrm/query/driver',
    // paramType: true, // 是否采用param对象传参
    cbParams: ['driverCode#codes', 'driverName#names']
};